module.exports = __webpack_public_path__ + "img/taifeng.6685991d.png";